import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Collapse from "@material-ui/core/Collapse";

/*Home*/
import { Auth } from "aws-amplify";
import HomeIcon from "@material-ui/icons/Home";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import Email from '@material-ui/icons/Email/';
import Featureflag from '../../utils/featureFlag.js';
import Group from "@material-ui/icons/Group";
import GasPumpIcon from "../../img/petrolpump.svg";
import { Icon } from "@material-ui/core";

function ListItemLink(props) {
  return <ListItem button component="li" {...props} />;
}

class SideMenu extends React.Component {
  state = {
    open: false,
    open1: false,
    open2: false,
    is_user_hq: false,
    currentUserRole: null,
  };

  async componentDidMount() {
    const user = await Auth.currentAuthenticatedUser();
    let list_group =
      user.signInUserSession.accessToken.payload["cognito:groups"];
    if (list_group) {
      list_group.map((value, index) => {
        if (value !== null && value !== undefined && value !== "") {
          this.setState({ currentUserRole: value });
        }
        if (value == "hq") {
          this.setState({ is_user_hq: true });
        }
      });
    }
  }

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleClick1 = () => {
    this.setState((state) => ({ open1: !state.open1 }));
  };

  handleClick2 = () => {
    this.setState((state) => ({ open2: !state.open2 }));
  };

  handleSecondMenu = () => {
    this.setState((state) => ({ openSecond1: !state.openSecond1 }));
  };

  render() {
    const { openMenu } = this.props;
    const { is_user_hq, currentUserRole } = this.state;
    return (
      <div className="side-menu">
        <List>
          <ListItemLink>
            <Link to="/">
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText inset primary="Home" />
            </Link>
          </ListItemLink>
          {currentUserRole === "petco_admin" && Featureflag.autogr ? (
            <ListItemLink>
              <Link to="/grhome">
                <ListItemIcon>
                  <LocalGasStationIcon />
                </ListItemIcon>
                <ListItemText inset primary="Auto&nbsp;GR" />
              </Link>
            </ListItemLink>
          ) : null}
          {currentUserRole === "petco_surveyor" && Featureflag.autogr ? (
            <ListItemLink>
              <Link to="/grhome">
                <ListItemIcon>
                  <LocalGasStationIcon />
                </ListItemIcon>
                <ListItemText inset primary="Auto&nbsp;GR" />
              </Link>
            </ListItemLink>
          ) : null}
          {currentUserRole === "petco_admin" && Featureflag.autogr ? (
            <ListItemLink>
              <Link to="/updateSurveyorEmail">
                <ListItemIcon>
                  <Email />
                </ListItemIcon>
                <ListItemText inset primary="Surveyor&nbsp;Email" />
              </Link>
            </ListItemLink>
          ) : null}
          <ListItemLink>
            <Link to="/myaccount">
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText inset primary="Account" />
            </Link>
          </ListItemLink>
        </List>
      </div>
    );
  }
}

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/SideMenu/SideMenu.js